// Mode & Product Unified Section
if (window.modeAndProductInitialized) {
	console.log("⚠️ Mode & Product already initialized, skipping...");
} else {
	window.modeAndProductInitialized = true;

	(function () {
		"use strict";

		// 初期化状態管理
		let initializationInProgress = false;
		let initializationCompleted = false;

		// モードデータをLiquidから取得
		let modeData = {};
		const modeDataElement = document.getElementById("mode-data");
		if (modeDataElement) {
			try {
				modeData = JSON.parse(modeDataElement.textContent);
			} catch (e) {
				console.error("Mode data parsing error:", e);
				// フォールバック用のデフォルトデータ
				modeData = {
					1: { title: "Run mode", description: "Fast. Agile.<br>It's a breeze." },
					2: { title: "Wait mode", description: "Sit and wait.<br>Park in a tiny space." },
					3: { title: "Walk mode", description: "Walk it. Roll it.<br>Wherever you go." },
					4: { title: "Sleep mode", description: "Never been<br>more compact." },
				};
			}
		}

		// グローバル変数
		let swiper = null;
		const totalSlides = 4;
		let isInitialized = false;

		// デバイス判定
		const isMobile = () => window.innerWidth <= 750;

		// 初期化メイン関数
		window.initModeAndProduct = function initModeAndProduct() {
			console.log("🎯 initModeAndProduct called");

			// 重複初期化チェック
			if (initializationInProgress || initializationCompleted) {
				console.log("⚠️ Initialization already in progress or completed, skipping...");
				return;
			}

			const swiperContainer = document.querySelector(".c_mode-and-product .swiper");
			const sectionElement = document.querySelector(".c_mode-and-product");

			if (!swiperContainer || !sectionElement) {
				console.log("❌ Required elements not found");
				return;
			}

			// 初期化開始フラグを設定
			initializationInProgress = true;
			console.log("🚀 Initializing unified Mode & Product section");

			// 段階的初期化プロセス
			initializeStepByStep();
		};

		// 段階的初期化プロセス
		function initializeStepByStep() {
			const mobile = isMobile();

			console.log("🚀 Starting step-by-step initialization, mobile:", mobile);

			// Step 1: 基本的な表示状態を確立
			setupBasicDisplay();

			// Step 2: Swiper初期化
			setTimeout(() => {
				try {
					initSwiper();
				} catch (error) {
					console.error("❌ Swiper initialization error:", error);
				}
			}, 100);

			// Step 3: ピクトグラム初期化
			setTimeout(() => {
				try {
					initPictograms();
				} catch (error) {
					console.error("❌ Pictograms initialization error:", error);
				}
			}, 300);

			// Step 4: ScrollTrigger初期化（KV競合対策強化版）
			setTimeout(
				() => {
					try {
						// KVシーケンスの存在確認
						const kvSection = document.querySelector(".c-kv-sequence");
						const baseDelay = mobile ? 1500 : 800;
						const kvDelay = kvSection ? 3000 : 0;
						
						console.log("⏰ ScrollTrigger initialization timing:", {
							mobile: mobile,
							kvSection: !!kvSection,
							baseDelay: baseDelay,
							kvDelay: kvDelay,
							totalDelay: baseDelay + kvDelay
						});
						
						if (kvDelay > 0) {
							console.log("⏳ KV sequence detected, waiting additional " + kvDelay + "ms");
						}
						
						setTimeout(() => {
							initScrollTriggerWithRetry();
						}, kvDelay);
						
					} catch (error) {
						console.error("❌ ScrollTrigger initialization error:", error);
					}
				},
				mobile ? 1500 : 800
			);

			// Step 5: 最終確認
			setTimeout(
				() => {
					try {
						finalizeInitialization();
					} catch (error) {
						console.error("❌ Finalization error:", error);
					}
				},
				mobile ? 3000 : 2000
			);
		}

		// 基本的な表示状態を確立
		function setupBasicDisplay() {
			const container = document.querySelector(".c-mode-product-container");
			const modeSection = document.querySelector(".c-mode-product-intro-section");
			const productSection = document.querySelector(".c-mode-product-featured-section");

			if (!container || !modeSection || !productSection) {
				console.error("❌ Basic display setup failed - elements not found");
				return;
			}

			// 初期状態設定
			gsap.set([container, modeSection, productSection], {
				opacity: 1,
				visibility: "visible",
				display: "block",
			});

			console.log("✅ Basic display setup completed");
		}

		// ScrollTrigger初期化（KV競合対応強化版）
		function initScrollTriggerWithRetry() {
			const maxRetries = 5;
			let retryCount = 0;

			function attemptInit() {
				try {
					// KVシーケンスの状態を詳細チェック
					const kvStatus = checkKVSequenceStatus();
					console.log("📊 KV Sequence status check:", kvStatus);
					
					if (!kvStatus.canProceed) {
						console.log(`⏳ KV sequence not ready, retry ${retryCount + 1}/${maxRetries}`);
						retryCount++;
						if (retryCount < maxRetries) {
							setTimeout(attemptInit, kvStatus.suggestedDelay);
							return;
						} else {
							console.warn("⚠️ Proceeding despite KV sequence status");
						}
					}
					
					const success = initScrollTrigger();
					if (success) {
						console.log("✅ ScrollTrigger initialized successfully");
						return;
					}
				} catch (error) {
					console.error("❌ ScrollTrigger initialization error:", error);
				}

				retryCount++;
				if (retryCount < maxRetries) {
					console.log(`🔄 Retrying ScrollTrigger initialization (${retryCount}/${maxRetries})`);
					setTimeout(attemptInit, 1000);
				} else {
					console.error("❌ ScrollTrigger initialization failed after all retries");
					setupFallbackDisplay();
				}
			}

			attemptInit();
		}

		// KVシーケンスの状態詳細チェック
		function checkKVSequenceStatus() {
			const kvTrigger = ScrollTrigger.getById("kv-sequence-trigger");
			const kvSection = document.querySelector(".c-kv-sequence");
			const kvInitialized = window.kvSequenceInitialized;
			
			// KVシーケンスが存在するが初期化中の場合
			if (kvSection && !kvInitialized) {
				return {
					canProceed: false,
					reason: "KV sequence initializing",
					suggestedDelay: 1000
				};
			}
			
			// KVトリガーがアクティブな場合
			if (kvTrigger && kvTrigger.isActive) {
				return {
					canProceed: false,
					reason: "KV trigger is active",
					suggestedDelay: 1500
				};
			}
			
			// KVトリガーが存在するが進行中の場合
			if (kvTrigger && kvTrigger.progress > 0 && kvTrigger.progress < 1) {
				return {
					canProceed: false,
					reason: "KV sequence in progress",
					suggestedDelay: 2000
				};
			}
			
			return {
				canProceed: true,
				reason: "KV sequence ready or completed"
			};
		}

		// フォールバック表示
		function setupFallbackDisplay() {
			const container = document.querySelector(".mode-and-product-container");
			if (!container) return;

			gsap.set(container, {
				opacity: 1,
				visibility: "visible",
			});

			console.log("🛡️ Fallback display activated");
		}

		// 最終初期化確認
		function finalizeInitialization() {
			isInitialized = true;
			initializationInProgress = false;
			initializationCompleted = true;
			console.log("✅ Mode & Product initialization finalized");

			// リサイズ対応を設定
			setupResizeHandlers();
		}

		// リサイズ対応の設定
		function setupResizeHandlers() {
			let resizeTimer;
			window.addEventListener("resize", () => {
				if (isInitialized) {
					clearTimeout(resizeTimer);
					resizeTimer = setTimeout(() => {
						ScrollTrigger.refresh();
						if (swiper) {
							swiper.update();
						}
					}, 250);
				}
			});
		}

		// Swiper初期化
		function initSwiper() {
			if (typeof Swiper === "undefined") {
				console.error("❌ Swiper library not loaded");
				return;
			}

			swiper = new Swiper(".c-mode-product-swiper", {
				slidesPerView: isMobile() ? 1 : 1.2,
				spaceBetween: isMobile() ? 30 : 100,
				centeredSlides: !isMobile(),
				allowTouchMove: false,
				loop: false,
				speed: 600,
				effect: "slide",
				grabCursor: false,

				// レスポンシブ設定
				breakpoints: {
					751: {
						slidesPerView: 1.2,
						spaceBetween: 100,
						centeredSlides: true,
						allowTouchMove: false,
						grabCursor: false,
					},
					320: {
						slidesPerView: 1,
						spaceBetween: 30,
						centeredSlides: false,
						allowTouchMove: false,
						grabCursor: false,
					},
				},

				on: {
					slideChange: function () {
						console.log("📱 Swiper slide changed to:", this.activeIndex);
						updateModeDisplay(this.activeIndex);
					},
					init: function () {
						console.log("✅ Swiper initialized");
						updateModeDisplay(0);
					},
				},
			});

			console.log("🎠 Swiper created:", swiper);
		}

		// ピクトグラム初期化
		function initPictograms() {
			const pictograms = document.querySelectorAll(".c-mode-product-pictogram");

			pictograms.forEach((pictogram, index) => {
				if (index === 0) pictogram.classList.add("active");

				const handleSlideChange = (e) => {
					e.preventDefault();
					e.stopPropagation();
					console.log("🖱️ Pictogram clicked:", index);
					if (swiper) {
						swiper.slideTo(index);
					}
				};

				pictogram.addEventListener("click", handleSlideChange);
				pictogram.addEventListener("touchend", handleSlideChange);
			});
		}

		// ScrollTrigger初期化
		function initScrollTrigger() {
			const container = document.querySelector(".c-mode-product-container");
			const modeSection = document.querySelector(".c-mode-product-intro-section");
			const productSection = document.querySelector(".c-mode-product-featured-section");

			if (!container || !modeSection || !productSection || typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
				console.error("❌ Required libraries or elements not found");
				return false;
			}

			gsap.registerPlugin(ScrollTrigger);

			// 強化されたKVシーケンス競合チェック
			const kvStatus = checkKVSequenceStatus();
			if (!kvStatus.canProceed) {
				console.log("⏳ KV sequence conflict detected:", kvStatus.reason);
				return false;
			}

			const mobile = isMobile();
			console.log("📱 Mobile device detected:", mobile);

			// 既存のScrollTriggerをクリーンアップ
			cleanupExistingTriggers();

			// 統合ScrollTrigger作成
			return createUnifiedScrollTrigger(container, modeSection, productSection, mobile);
		}

		// 既存のScrollTriggerをクリーンアップ
		function cleanupExistingTriggers() {
			const existingTriggers = ScrollTrigger.getAll().filter(trigger => 
				trigger.vars.id === "mode-and-product-unified" ||
				(trigger.vars.trigger && trigger.vars.trigger.classList && 
				 trigger.vars.trigger.classList.contains('c-mode-product-container'))
			);
			
			if (existingTriggers.length > 0) {
				console.log("🧹 Cleaning up existing unified triggers:", existingTriggers.length);
				existingTriggers.forEach(trigger => trigger.kill());
			}
		}

		// 統合ScrollTrigger作成
		function createUnifiedScrollTrigger(container, modeSection, productSection, mobile) {
			console.log("🎬 Creating unified ScrollTrigger");

			// コンテナの高さを設定（Mode部分 + Product部分）
			const containerHeight = mobile ? "500vh" : "400vh";
			
			gsap.set(container, {
				height: containerHeight,
				opacity: 1,
				visibility: "visible",
			});

			try {
				const config = {
					trigger: container,
					start: "top top",
					end: "bottom bottom",
					pin: modeSection,
					pinSpacing: true,
					priority: 0,
					preventOverlaps: true,
					id: "mode-and-product-unified",
					
					onUpdate: (self) => {
						const progress = self.progress;
						
						console.log("🎬 Unified onUpdate:", {
							progress: progress.toFixed(3),
							scrollY: window.pageYOffset
						});
						
						// Mode Introduction部分（progress 0 - 0.7）
						if (progress <= 0.7 && isInitialized && swiper) {
							// Modeセクション表示
							gsap.set(modeSection, {
								opacity: 1,
								visibility: "visible"
							});
							
							// スライド切り替え
							const modeProgress = progress / 0.7;
							const targetSlide = Math.floor(modeProgress * totalSlides);
							const clampedSlide = Math.max(0, Math.min(totalSlides - 1, targetSlide));

							if (swiper.activeIndex !== clampedSlide) {
								console.log("📱 Sliding to:", clampedSlide);
								swiper.slideTo(clampedSlide, 300);
								updateModeDisplay(clampedSlide);
							}
						}
						
						// Featured Product部分への移行（progress 0.7 - 1.0）
						if (progress > 0.7) {
							console.log("🎯 Transitioning to featured product");
							
							// Mode部分を徐々に非表示
							const fadeProgress = (progress - 0.7) / 0.3;
							gsap.set(modeSection, {
								opacity: Math.max(0, 1 - fadeProgress),
							});
							
							// 完全に移行したらピン留めを解除
							if (progress > 0.95) {
								console.log("🎯 Ready to show product section");
							}
						}
					},
					
					onLeave: (self) => {
						console.log("🎯 Unified onLeave - transitioning to product");
						
						// Mode部分を完全に非表示
						gsap.set(modeSection, {
							opacity: 0,
							visibility: "hidden"
						});
						
						// Product部分を表示
						gsap.set(productSection, {
							opacity: 1,
							visibility: "visible",
							position: "relative",
							zIndex: "auto"
						});
					},
					
					onEnterBack: (self) => {
						console.log("🎯 Unified onEnterBack - back to mode");
						
						// Mode部分を再表示
						gsap.set(modeSection, {
							opacity: 1,
							visibility: "visible"
						});
					}
				};

				const trigger = ScrollTrigger.create(config);

				if (trigger) {
					console.log("✅ Unified ScrollTrigger created");
					return true;
				} else {
					return false;
				}
			} catch (error) {
				console.error("❌ Unified ScrollTrigger error:", error);
				return false;
			}
		}

		// モード表示更新
		function updateModeDisplay(activeIndex) {
			const modeIndex = activeIndex + 1;
			console.log("🎯 Updating mode display:", { activeIndex, modeIndex });

			// ピクトグラム更新
			const pictograms = document.querySelectorAll(".c-mode-product-pictogram");
			pictograms.forEach((pictogram, index) => {
				pictogram.classList.remove("active");
				if (index === activeIndex) pictogram.classList.add("active");
			});

			// タイトル・説明更新
			const titleElement = document.getElementById("c-mode-product-title");
			const descriptionElement = document.getElementById("c-mode-product-description");

			if (titleElement && descriptionElement && modeData[modeIndex]) {
				titleElement.textContent = modeData[modeIndex].title;
				descriptionElement.innerHTML = modeData[modeIndex].description;
			}
		}

		// DOM読み込み後の初期化
		if (document.readyState === "loading") {
			document.addEventListener("DOMContentLoaded", () => {
				console.log("📜 DOMContentLoaded event fired");
				if (!initializationInProgress && !initializationCompleted) {
					console.log("🚀 Starting initialization from DOMContentLoaded");
					initModeAndProduct();
				}
			});
		} else {
			console.log("📜 DOM already loaded, using setTimeout");
			setTimeout(() => {
				if (!initializationInProgress && !initializationCompleted) {
					console.log("🚀 Starting initialization from setTimeout");
					initModeAndProduct();
				}
			}, 100);
		}

		console.log("📜 Mode & Product script loaded at:", new Date().toISOString());
	})();
}